import { v4 as uuid } from 'uuid';

export default function prepareBulkUpdateMutationInputs(updateRequests, createId = uuid) {
  // GraphQL fields cannot reference ids returned by earlier fields, so resolve
  // every parent and child id before building the atomic mutation variables.
  return updateRequests.map(
    ({
      pipelineId,
      integrationId,
      pipelineIntegrationId,
      stagedRevisionId,
      consentId,
      consentCategoryId,
      consentMode,
      playbookId,
      pipelineVars,
      disabled,
      readyForDeploy,
      stagedForDelete,
    }) => {
      return {
        pipelineId,
        integrationId,
        pipelineIntegrationId: pipelineIntegrationId ?? createId(),
        isNewPipelineIntegration: !pipelineIntegrationId,
        stagedRevisionId: stagedRevisionId ?? createId(),
        playbookId,
        pipelineVars,
        disabled,
        readyForDeploy,
        stagedForDelete,
        consent: buildConsent({ consentId, consentCategoryId, consentMode }, createId),
      };
    }
  );
}

function buildConsent({ consentId, consentCategoryId, consentMode }, createId) {
  if (!consentCategoryId && !consentMode) {
    return null;
  }

  return {
    id: consentId ?? createId(),
    isNew: !consentId,
    categoryId: consentCategoryId,
    mode: consentMode,
  };
}
